import React from 'react';
import { useNavigate } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Fascia promozionale trasversale in home (tipo Temu). Appare subito dopo
 * che l'utente ha chiuso il popup banner corrispondente e resta visibile
 * finché non scade (banner_expires_at, impostato dall'admin) — non è
 * chiudibile manualmente dall'utente. */
const HomeBanner = ({ notification }) => {
  const navigate = useNavigate();
  if (!notification?.image_path) return null;

  const imageUrl = `${API}/thumbnails/${notification.image_path}`;
  const hasLink = !!notification.url;
  const hasText = !!(notification.title || notification.body);

  const handleOpen = () => {
    if (!hasLink) return;
    if (/^https?:\/\//i.test(notification.url)) {
      window.open(notification.url, '_blank', 'noopener,noreferrer');
    } else {
      navigate(notification.url);
    }
  };

  return (
    <button
      type="button"
      onClick={handleOpen}
      disabled={!hasLink}
      className={`block w-full text-left mb-6 rounded-2xl overflow-hidden border border-zinc-200 shadow-sm bg-white ${hasLink ? 'cursor-pointer' : 'cursor-default'}`}
      data-testid="home-banner"
    >
      <img
        src={imageUrl}
        alt={notification.title || ''}
        className="w-full aspect-[2.5/1] object-cover bg-zinc-100"
      />
      {hasText && (
        <div className="p-4">
          {notification.title && (
            <p className="font-semibold text-zinc-900">{notification.title}</p>
          )}
          {notification.body && (
            <p className="text-zinc-600 text-sm mt-1">{notification.body}</p>
          )}
        </div>
      )}
    </button>
  );
};

export default HomeBanner;
